export const TreeElementType = Object.freeze({
    Branch: 'branch',
    Leaf: 'leaf',
});
